'use client';

import { useCallback } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Modal } from '@components/common/Modal/Modal';
import { useReduxUser } from '@hooks/common/useAuthClient/useReduxUser';
import GeminiVoiceWidget from '@components/features/voice/GeminiVoiceWidget';
import { fetchBestieVoiceSession } from '@services/voice/voiceSessionApi';

export const BestieVoiceModal = NiceModal.create(() => {
  const modal = useModal();
  const { t } = useTranslation('common');
  const { headerInfo } = useReduxUser();
  const typedHeaderInfo = headerInfo;
  const isAuthenticated = !!typedHeaderInfo?.userId;
  // Greeting depends on account type (candidate vs company), derived from the business wallet.
  const isCandidate = !typedHeaderInfo?.hasBusinessWallet;
  // `name` is the wallet/billing name — the *company* on an employer account. The person's
  // own name is `candidateName` (HeaderInfoBuilder sets it from $user->getName() for both
  // roles), which is what the greeting should use. Falls back to empty rather than to the
  // company name, so a missing name just drops out of the sentence. Logged-out users have
  // no headerInfo at all, so the guard is implicit.
  const firstName = typedHeaderInfo?.candidateName?.trim().split(' ')[0] ?? '';

  const firstMessageKey = isCandidate
    ? (isAuthenticated ? 'inbound.greeting.candidat.logged' : 'inbound.greeting.candidat.not_logged')
    : (isAuthenticated ? 'inbound.greeting.employer.logged' : 'inbound.greeting.employer.not_logged');

  const firstMessage = t(firstMessageKey, { first_name: firstName });

  const closeModal = useCallback(() => {
    void modal.hide();
    modal.remove();
  }, [modal]);

  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      backdropClickDisabled
      size="sm"
      className="!max-w-sm !rounded-3xl"
      body={<GeminiVoiceWidget firstMessage={firstMessage} fetchSession={fetchBestieVoiceSession} onClose={closeModal} />}
    />
  );
});
